import { ItineraryService } from './../itinerary.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Itinerary } from './../itineray.model';
import { Component, OnInit } from '@angular/core';
import { v4 as uuid } from "uuid";

@Component({
  selector: 'app-itinerary-reservations-buses',
  templateUrl: './itinerary-reservations-buses.component.html',
  styleUrls: ['./itinerary-reservations-buses.component.css']
})
export class ItineraryReservationsBusesComponent implements OnInit {

  constructor(private route: ActivatedRoute, private snackBar: MatSnackBar, public itineraryService: ItineraryService) { }

  itinerary: Itinerary;

  expanded: boolean[];

  ngOnInit() {
    this.itinerary = this.route.parent.parent.snapshot.data.itinerary;
    this.syncExpanded();
  }

  private syncExpanded(expandLast: boolean = false) {
    this.expanded = [];
    this.itinerary.reservations.flights.forEach((item) => this.expanded.push(false));
    if (expandLast) {
      this.expanded[this.expanded.length - 1] = true;
    }
  }

  removeBus($event, bus) {
    $event.stopPropagation();
    if (confirm("Vuoi veramente eliminare questo autobus?")) {
      const idx = this.itinerary.reservations.buses.indexOf(bus);
      this.itinerary.reservations.buses.splice(idx, 1);
      this.snackBar
        .open("Autobus eliminato.", "Annulla", {
          duration: 4000
        })
        .onAction()
        .subscribe(() => {
          this.itinerary.reservations.buses.splice(idx, 0, bus);
          this.snackBar.open(
            "L'autobus che avevi eliminato è stata inserito nuovamente nella lista.",
            null,
            {
              duration: 4000
            }
          );
        });
      this.syncExpanded();
    }
  }

  addBus() {
    this.itinerary.reservations.buses.push({
      id: uuid(),
      notes: null,
      link: { longUrl: null, shortUrl: null },
      partner: null,
      price: null,
      routes: [
        {
          id: uuid(),
          title: "",
          company: "",
          code: "",
          from: "",
          fromDetail: "",
          fromCode: "",
          fromPlace: null,
          to: "",
          toDetail: "",
          toCode: "",
          toPlace: null,
          start: null,
          end: null,
          stops: null,
          duration: {
            hours: null,
            minutes: null
          }
        }
      ]
    });
    this.syncExpanded(true);
  }

}
